import React from 'react';
import Panel from './Panel';
import { IconFlow } from './icons';

/** Corridors origine-destination, triés par volume décroissant. */
export default function ODFlowPanel({ data, delay = 0 }) {
  const zones = data?.zones || [];
  const nameOf = (id) => zones.find((z) => z.id === id)?.nom || id;

  const flows = [...(data?.flows || [])].sort((a, b) => b.volume - a.volume);
  const max = flows.length ? flows[0].volume : 1;

  return (
    <Panel
      icon={IconFlow}
      title="Corridors origine-destination"
      sub={data?.unit || 'déplacements/jour'}
      badge={`${flows.length} corridors`}
      delay={delay}
    >
      {flows.length === 0 && <div className="empty">Aucun flux disponible.</div>}
      {flows.map((f, i) => (
        <div className="flow" key={`${f.origin}-${f.destination}`}>
          <div className="flow__head">
            <div className="flow__route">
              <span>{nameOf(f.origin)}</span>
              <span className="arrow">→</span>
              <span>{nameOf(f.destination)}</span>
              <span className="flow__zone-id">{f.origin} · {f.destination}</span>
            </div>
            <span className="flow__vol">{f.volume.toLocaleString('fr-FR')}</span>
          </div>
          <div className="flow__bar">
            <div
              className="flow__fill"
              style={{ width: `${(f.volume / max) * 100}%`, animationDelay: `${delay + i * 70}ms` }}
            />
          </div>
        </div>
      ))}
    </Panel>
  );
}
